import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import { isFunction, isString } from '../utils/base'

Vue.use(Router)

function scrollBehavior() {
  return {
    x: 0,
    y: 0
  }
}

const _wzEnv_ = window._wzEnv_ || {}
const { appDir } = _wzEnv_

const router = new Router({
  mode: 'history',
  base: '/award2019/upgrade/',
  routes,
  scrollBehavior
})
// const router = new Router({ routes });

// router.beforeEach((to, from, next) => {
//     // console.log('router.beforeEach')
//     const {
//         path
//     } = to
//     if (/^\/(?:my)\/?/.test(path)) {
//         // console.log('TODO: 检测是否已登录')
//         next()
//     } else {
//         next()
//     }
// })

// let referrerUrl = document.referrer || ''
router.afterEach(to => {
  const {
    // params,
    meta
  } = to
  let title = meta && meta.title
  if (isFunction(title)) {
    const { params, query } = to
    title = title(params || {}, query || {})
  }
  if (isString(title)) {
    document.title = title
  }
  // params.categoryId = 100

  // console.log('router.afterEach' + params.categoryId)

  // referrerUrl = from.fullPath

  // const {name, path} = to
  // console.log({referrerUrl, name, title : title || name, path})
})
// router.onReady(function (params) {
//   console.log(JSON.stringify(params, null, 2))
// })

export default router
